import { DatePipe } from '@angular/common';
import {
  Component,
  computed,
  inject,
  linkedSignal,
  model,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { queryParam, SOFTLINE_FEATURE_TITLE, TitleStore } from '@softline/application';
import { DateService, isIsoDate, IsoDate, Store } from '@softline/core';
import { DateNavigatorService } from '../services/date-navigator.service';

import { DateNavigatorComponent } from '@softline/ui-core/date';
@Component({
  selector: 'soft-basisartikelstand',
  imports: [RouterModule,
    DateNavigatorComponent],
  templateUrl: './basisartikelstand.component.html',
  styleUrls: ['./basisartikelstand.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DateNavigatorService, DatePipe] })
export class BasisartikelstandComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly store = inject(Store);
  private readonly dateService = inject(DateService);

  // readonly date = model<IsoDate>(this.dateService.now());

  private readonly queryDate = queryParam('date');

  readonly date = linkedSignal(() => {
    const date = this.queryDate();
    if (!date || !isIsoDate(date)) return this.dateService.now();

    return date;
  });

  async ngOnInit(): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      'Basisartikelstand'
    );
  }

  ngOnDestroy(): void {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
  }

  dateChange(date: string): void {
    this.router.navigate(['./'], {
      queryParams: { date },
      relativeTo: this.route });
  }
}
